// eslint-disable-next-line no-unused-vars
import { Children, cloneElement, useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useDeleteTariffPlanResourceMutation, useLazyGetTariffPlansQuery } from '../redux/tariffPlansResource.api';
import useAuth from '../../../../shared/lib/hooks/useAuth';

const transformFiltersToReqParams = (curFilters) => {
  return {
    'name.contains': curFilters.name,
    'dealerCompanyId.equals': curFilters.dealerCompany?.companyId,

    ...(curFilters.startDate && { 'startDate.greaterThanOrEqual': curFilters.startDate.toISOString() }),
    ...(curFilters.startDateUntil && { 'startDate.lessThanOrEqual': curFilters.startDateUntil.toISOString() }),
    ...(curFilters.finishDate && { 'finishDate.greaterThanOrEqual': curFilters.finishDate.toISOString() }),
    ...(curFilters.finishDateUntil && { 'finishDate.lessThanOrEqual': curFilters.finishDateUntil.toISOString() }),
  };
};

// Компонента Бизнес уровня которая является связующим звеном между фронтом и бизнесом
// Компонента возвращает Children с новыми пропсами из бизнес уровня
function TariffPlansResourceBll({ children }) {
  const { isDealer, companyAccount } = useAuth();
  const { companyId } = companyAccount?.company || {};

  // Текущая страница
  const [page, setPage] = useState(0);
  // Общее кол-во тарифов
  const [totalCount, setTotalCount] = useState(0);

  const [filters, setFilters] = useState();

  // Смена страницы
  const handleChangePage = (event, value) => {
    setPage(value);
  };

  const handleFilters = (curFilters) => {
    setFilters(transformFiltersToReqParams(curFilters));
  };

  const [rowsPerPage, setRowsPerPage] = useState(5);

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const [getGetTariffPlans, tariffPlansResource] = useLazyGetTariffPlansQuery();
  const [deleteTariffPlanResource, { status: deleteStatus }] = useDeleteTariffPlanResourceMutation();

  const refresh = useCallback(() => {
    getGetTariffPlans({
      params: {
        ...filters,
        page,
        size: rowsPerPage,
        ...(isDealer && { 'dealerCompanyId.equals': companyId }),
      },
    });
  }, [filters, page, rowsPerPage, getGetTariffPlans, isDealer, companyId]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  useEffect(() => {
    setTotalCount(tariffPlansResource.data?.totalCount ? Number(tariffPlansResource.data?.totalCount) : 0);
  }, [tariffPlansResource]);

  const props = {
    tariffPlansResource,
    handleChangePage,
    page,
    handleChangeRowsPerPage,
    handleFilters,
    totalCount,
    rowsPerPage,
    deleteTariffPlan: deleteTariffPlanResource,
    deleteStatus,
    refresh,
  };

  return Children.toArray(children).map((child) => cloneElement(child, props));
}

TariffPlansResourceBll.propTypes = {
  children: PropTypes.element.isRequired,
};

export default TariffPlansResourceBll;
